// utils/propertyFilters.js

// Tab configuration
export const tabs = [
  { label: "Purchase", value: "Purchase" },
  { label: "Rent", value: "Rent" },
  { label: "Lease", value: "Lease" },
  { label: "JD/JV", value: "jv/jd" },
  { label: "Build Suit", value: "build to suit" }
];

// Sample locations data
export const popularCities = [
  "Delhi", "Mumbai", "Bangalore", "Hyderabad", "Chennai",
  "Kolkata", "Pune", "Ahmedabad", "Jaipur", "Lucknow"
];

export const propertyTypes = [
  "Plot", "Building", "Apartment", "Villa", "Commercial",
  "Agricultural", "Industrial", "Residential Plot", "Commercial Plot"
];

// Main filtration function
export const filterProperties = (properties, filters) => {
  const {
    searchQuery,
    activeTab,
    selectedLocations,
    selectedPropertyTypes,
    tabs
  } = filters;

  return properties.filter(property => {
    const matchesSearch = 
      property.property_type?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      property.location?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      property.looking_for?.toLowerCase().includes(searchQuery.toLowerCase());
    
    const matchesTab = 
      tabs[activeTab] && 
      property.looking_for?.toLowerCase().includes(tabs[activeTab].value.toLowerCase());
    
    const matchesLocations = selectedLocations.length === 0 || 
      selectedLocations.some(location => 
        property.location?.toLowerCase().includes(location.toLowerCase())
      );
    
    const matchesPropertyTypes = selectedPropertyTypes.length === 0 ||
      selectedPropertyTypes.some(type => 
        property.property_type?.toLowerCase().includes(type.toLowerCase())
      );
    
    return matchesSearch && matchesTab && matchesLocations && matchesPropertyTypes;
  });
};

// Location filter handlers
export const locationHandlers = {
  handleLocationSelect: (selectedLocations, setSelectedLocations, location) => {
    if (selectedLocations.length < 3 && !selectedLocations.includes(location)) {
      setSelectedLocations([...selectedLocations, location]);
    }
  },

  handleLocationRemove: (selectedLocations, setSelectedLocations, locationToRemove) => {
    setSelectedLocations(selectedLocations.filter(location => location !== locationToRemove));
  },

  handleUseCurrentLocation: (useCurrentLocation, setUseCurrentLocation, setSelectedLocations) => {
    setUseCurrentLocation(!useCurrentLocation);
    if (!useCurrentLocation) {
      // Simulate getting current location
      setSelectedLocations(["Current Location"]);
    } else {
      setSelectedLocations([]);
    }
  }
};

// Property type filter handlers
export const propertyTypeHandlers = {
  handlePropertyTypeSelect: (selectedPropertyTypes, setSelectedPropertyTypes, type) => {
    if (selectedPropertyTypes.includes(type)) {
      setSelectedPropertyTypes(selectedPropertyTypes.filter(t => t !== type));
    } else {
      setSelectedPropertyTypes([...selectedPropertyTypes, type]);
    }
  }
};

// Utility functions
export const utilityFunctions = {
  formatBudget: (minBudget, maxBudget) => {
    const formatAmount = (amount) => {
      if (amount >= 10000000) {
        return `₹${(amount / 10000000).toFixed(1)}Cr`;
      } else if (amount >= 100000) {
        return `₹${(amount / 100000).toFixed(1)}L`;
      } else {
        return `₹${amount}`;
      }
    };
    
    return `${formatAmount(minBudget)} - ${formatAmount(maxBudget)}`;
  },

  formatDate: (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  },

  getUserInitials: (userId) => {
    return "U";
  }
};